
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import TopPropertiesTab from "./tabs/TopPropertiesTab";
import InquiriesTab from "./tabs/InquiriesTab";
import NotificationsTab from "./tabs/NotificationsTab";

const DashboardTabs = () => {
  return (
    <Tabs defaultValue="properties" className="space-y-4">
      <TabsList>
        <TabsTrigger value="properties">Top Properties</TabsTrigger>
        <TabsTrigger value="inquiries">Recent Inquiries</TabsTrigger>
        <TabsTrigger value="notifications">Notifications</TabsTrigger>
      </TabsList>
      
      <TabsContent value="properties">
        <TopPropertiesTab />
      </TabsContent>
      
      <TabsContent value="inquiries">
        <InquiriesTab />
      </TabsContent>

      <TabsContent value="notifications">
        <NotificationsTab />
      </TabsContent>
    </Tabs>
  );
};

export default DashboardTabs;
